import { OpenCallTypeUiConfig, OPEN_CALL_TYPE_IDS } from '../types';
import { getLegacyCandidateDisplay } from '../shared/candidate-display';
import { LEGACY_FILTER_DEFINITIONS } from '../filter-definitions';
import { getLegacyCandidateAboutConfig } from '../shared/candidate-about';

export const openCastingUiConfig: OpenCallTypeUiConfig = {
  typeId: OPEN_CALL_TYPE_IDS.OpenCasting,

  filters: {
    definitions: LEGACY_FILTER_DEFINITIONS,
    enabled: true,
  },

  candidateCard: {
    getDisplay: getLegacyCandidateDisplay,
  },

  candidateList: {
    compact: false,
  },

  candidateDetails: {
    about: getLegacyCandidateAboutConfig(),
    showContact: true,
    showBio: true,
    showAttributes: true,
    parseBioAsQa: false,
  },

  bulkActions: {
    contactExport: true,
    copilotExport: true,
    dismiss: true,
    moveStage: true,
  },
};
